import React from "react";

class PowerIconLarge extends React.Component { 
    render() {
        return (
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0)">
			<path d="M12.072 23.1822C18.2085 23.1822 23.1832 18.2076 23.1832 12.0711C23.1832 5.93458 18.2085 0.959961 12.072 0.959961C5.93555 0.959961 0.960938 5.93458 0.960938 12.0711C0.960938 18.2076 5.93555 23.1822 12.072 23.1822Z" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M12.0714 16.5158C14.526 16.5158 16.5158 14.526 16.5158 12.0714C16.5158 9.6168 14.526 7.62695 12.0714 7.62695C9.6168 7.62695 7.62695 9.6168 7.62695 12.0714C7.62695 14.526 9.6168 16.5158 12.0714 16.5158Z" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M10.1172 8.07079L17.0505 2.11523" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M7.62834 11.8049L5.93945 2.82715" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M9.67205 15.8044L0.960938 12.7822" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M14.0271 16.0713L7.09375 22.0268" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M16.5156 12.3379L18.2045 21.3157" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			<path d="M14.4727 8.33789L23.1838 11.3601" stroke="#8A8B8D" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
			</g>
			<defs>
			<clipPath id="clip0">
			<rect width="24" height="24" fill="white"/>
			</clipPath>
			</defs>
			</svg>
			
			


        )
    }
}

export default PowerIconLarge;




